import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';


@Component({
})
export default class OCTextBox extends Mixins(BASEComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: [String, Number],
        default: "",
    })
    public value!: string | number;

    @Prop({
        type: Boolean,
        default: false,
    })
    public readonly!: boolean;

    @Emit("input")
    public input(val: string | number) {
        return val;
    }

    public get localVal(): string {
        if (typeof this.value === "number") {
            return "" + this.value;
        } else {
            return this.value;
        }
    }

    public set localVal(val: string) {
        if (typeof this.value === "number") {
            this.input(Number(val));
        } else {
            this.input(val);
        }
    }

    @Prop({
        type: String,
        default: "",
    })
    public placeholder!: string;

    @Prop({
        type: String,
        default: "",
    })
    public enPlaceholder!: string;

    @Prop({
        type: String,
        default: "text",
    })
    public type!: string;

    @Prop({
        type: String,
        default: "",
    })
    public pattern!: string;
}